import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';

const advantages = [
  {
    title: "Clinics & Rehabilitation Centers",
    description: "Use real-time transcription and correction tools to improve speech therapy and communication outcomes.",
  },
  {
    title: "Health App Developers",
    description: "Integrate our SDKs for ASR, patient profiling, and chatbot diagnostics in digital health platforms.",
  },
  {
    title: "Hospitals & Long-Term Care",
    description: "Embed edge inference tools for on-premise analytics where privacy and latency matter.",
  },
  {
    title: "MedTech & Device Manufacturers",
    description: "Partner to develop smart devices with embedded predictive or corrective intelligence.",
  },
  {
    title: "IoT Health Sensor Vendors",
    description: "Connect wearable and environmental sensors with our models for smarter remote care.",
  },
  {
    title: "Academic & Research Labs",
    description: "Collaborate on AI model tuning, dataset creation, and ethics-guided innovation in health AI.",
  },
]

const Advantage = () => {
  return (
    <>
      <Element
        name="Advantage"
        className="datatalent-section-gap solutions-advantage"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center text-white"
                title = "Healthcare Ecosystem Integration"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center color-white">Seamless AI Solutions Across the Health Value Chain.</p>
            </div>
            {advantages.map((adv) =>
              <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={adv.title}>
                <div className="advantage-card p-4 h-100">
                  <h5 className="mt-3 mb-3 color-white">{adv.title}</h5>
                  <p className="mb-3">{adv.description}</p>
                </div>
            </div>
            )}
          </div>
        </div>
      </Element>
    </>
  )
}

export default Advantage;